import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import NavBar from "../navbar";
import Footer from "../footer";

function Blog() {
  return (
    <div>
      <NavBar />
      <section className="page-content">
        <Container>
          <div style={{ marginTop: "2%", backgroundColor: "" }}>
            <div className="blog-content" style={{ marginLeft: "9%", marginRight: "9%" }}>
              <p align="left">
                <h1>
                  <b>All Posts</b>
                </h1>
              </p>
              <p align="justify">
              Sharing my knowledge and experiences with others while also keeping the conversation going about the latest developments in the software field.
              </p>
            </div>
          </div>
          <div style={{ paddingLeft: "4%", paddingRight: "4%" }}>
            <hr
              style={{ width: "90%", marginLeft: "auto", marginRight: "auto" }}
            ></hr>

            <Row>
              <Col md={4}>
                <p>26th June 2022</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Importance of Contributing to open-source projects
                  </p>
                  <p align="left">
                    <a href="#">
                      <a href="#">
                        <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                      </a>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>

            <br />
            <Row>
              <Col md={4}>
                <p>26th June 2022</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    The role of continuous learning in software development ✨
                  </p>
                  <p align="left">
                    <a href="#">
                      <a href="#">
                        <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                      </a>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>26th June 2022</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Collaborative Engineering: The Power of Hackathons 🏃🏻⏳
                  </p>
                  <p align="left">
                    <a href="https://www.linkedin.com/posts/aryan-kenchappagol_technology-team-deeplearning-activity-7031627401314938880-5EqW?utm_source=share&utm_medium=member_desktop">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>26th June 2022</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Frequently Asked Questions (FAQs) related to Google Summer
                    of Code
                  </p>
                  <p align="left">
                    <a href="#">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>13th Jan 2023</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    A Guide for Developers to Gain Valuable Experience and
                    Contribute to Open-Source Projects
                  </p>
                  <p align="left">
                    <a href="https://aryankx.hashnode.dev/google-summer-of-code-a-guide-for-developers-to-gain-valuable-experience-and-contribute-to-open-source-projects">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>2nd Nov 2021</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Add Custom App Icon and Name to your Flutter apk
                  </p>
                  <p align="left">
                    <a href="https://aryankx.hashnode.dev/add-custom-app-icon-and-name-to-your-flutter-apk">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>28th Mar 2021</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Recommendation Systems using Machine Learning
                  </p>
                  <p align="left">
                    <a href="https://medium.com/geekculture/recommendation-systems-using-machine-learning-e1d22b4a20fd">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>4th July 2021</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">
                    Machine Learning Model Deployment with Flask
                  </p>
                  <p align="left">
                    <a href="https://medium.com/mlearning-ai/machine-learning-model-deployment-with-flask-4d7c1c59e22f">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <p>21st Mar 2021</p>
              </Col>
              <Col md={6}>
                <h5>
                  <p align="left">Data Analysis Tools for Python</p>
                  <p align="left">
                    <a href="https://medium.com/analytics-vidhya/data-analysis-tools-for-python-354d2d16e5b5">
                      <h5 style={{ fontSize: "15px" }}>Read more →</h5>
                    </a>
                  </p>
                </h5>
              </Col>
            </Row>
            <br />
          </div>
        </Container>
      </section>
      <Footer />
    </div>
  );
}

export default Blog;
